import { Tooltip } from '@lokalise/louis';
import { type ReactNode, useRef } from 'react';

import { OverflowText } from './styles';

const OverflowTextTooltip = ({ children }: { children: ReactNode }) => {
    const ref = useRef<HTMLParagraphElement>(null);

    const isParagraphOverflow = ref.current ? ref.current.offsetWidth < ref.current.scrollWidth : false;

    return isParagraphOverflow ? (
        <Tooltip tooltip={children}>
            <OverflowText ref={ref}>{children}</OverflowText>
        </Tooltip>
    ) : (
        <OverflowText ref={ref}>{children}</OverflowText>
    );
};

export default OverflowTextTooltip;
